var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolioItem.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolioItem.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "ind"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("ind", Object.prototype.hasOwnProperty.call(kwargs, "ind") ? kwargs["ind"] : "");var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditPortfolioItem-inputWrapper\">\n\n        <input class=\"MemberProfileEditPortfolioItem-input\" type=\"text\" name=\"id\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n        <input class=\"MemberProfileEditPortfolioItem-input\" type=\"text\" name=\"component\" value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"component"), env.opts.autoescape);
t_5 += "\">\n\n        <div class=\"MemberProfileEditPortfolioItem-inputWrapper-imageWrapper\">\n            <input class=\"MemberProfileEditPortfolioItem-input\" type=\"file\" id=\"cover-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ind"), env.opts.autoescape);
t_5 += "\" name=\"cover\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")) {
t_5 += "data-file=\"";
t_5 += runtime.suppressValue(env.getFilter("tojson").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n\n            <img ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")) {
t_5 += "src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w680_url"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " alt=\"\">\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"component") == "image") {
t_5 += "\n                <label class=\"MemberProfileEditPortfolioItem-inputChange\" for=\"cover-";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ind"), env.opts.autoescape);
t_5 += "\">\n                    ";
t_5 += runtime.suppressValue((lineno = 15, colno = 42, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["avatar-edit","0 0 12 18",runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
t_5 += "\n                </label>\n            ";
;
}
t_5 += "\n\n            <div class=\"MemberProfileEditPortfolioItem-inputLoader\"></div>\n        </div>\n\n        <div class=\"MemberProfileEditPortfolioItem-inputWrapper-info\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"component") == "video") {
t_5 += "\n                <input class=\"MemberProfileEditPortfolioItem-input\" type=\"text\" name=\"videoProvider\" value=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoProvider")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoProvider"), env.opts.autoescape);
;
}
t_5 += "\">\n                <input class=\"MemberProfileEditPortfolioItem-input\" type=\"text\" name=\"videoCode\" value=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoCode")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoCode"), env.opts.autoescape);
;
}
t_5 += "\">\n                <input type=\"text\" name=\"videoUrl\" class=\"MemberProfileEditPortfolioItem-inputWrapper-info-inputEmbed\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoUrl")) {
t_5 += " value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoUrl"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " placeholder=\"Add YouTube or Vimeo link\">\n            ";
;
}
t_5 += "\n\n            <textarea type=\"text\" placeholder=\"Add Caption\" name=\"caption\" class=\"MemberProfileEditPortfolioItem-inputWrapper-info-inputCaption\">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"caption")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"caption"), env.opts.autoescape);
;
}
t_5 += "</textarea>\n        </div>\n\n        <div class=\"MemberProfileEditPortfolioItem-inputIcons\">\n                <div class=\"MemberProfileEditPortfolioItem-inputIcons-delete\">\n                        <div class=\"MemberProfileEditPortfolioItem-inputIcons-deleteItem MemberProfileEditPortfolioItem-inputIcons-deleteItem--top\"></div>\n                        <div class=\"MemberProfileEditPortfolioItem-inputIcons-deleteItem MemberProfileEditPortfolioItem-inputIcons-deleteItem--bottom\"></div>\n                </div>\n                <div class=\"MemberProfileEditPortfolioItem-inputIcons-drag\">\n                        <div class=\"MemberProfileEditPortfolioItem-inputIcons-dragItem MemberProfileEditPortfolioItem-inputIcons-dragItem--top\"></div>\n                        <div class=\"MemberProfileEditPortfolioItem-inputIcons-dragItem MemberProfileEditPortfolioItem-inputIcons-dragItem--middle\"></div>\n                        <div class=\"MemberProfileEditPortfolioItem-inputIcons-dragItem MemberProfileEditPortfolioItem-inputIcons-dragItem--bottom\"></div>\n                </div>\n        </div>\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"component") == "video") {
t_5 += "\n            <div class=\"MemberProfileEditPortfolioItem-info\">\n                <div class=\"MemberProfileEditPortfolioItem-infoIcon\">?</div>\n                <div class=\"MemberProfileEditPortfolioItem-infoPopup\">\n                    <span>If you'd like to add a video to your portfolio, simply upload your video to either YouTube or Vimeo, and once the upload is complete, you can copy and paste the URL in the field to the left and hit the SAVE button. Make sure your video is not password protected so visitors to your profile will be able to view it.</span>\n                    <div class=\"MemberProfileEditPortfolioItem-infoPopupCorner\"></div>\n                </div>\n            </div>\n        ";
;
}
t_5 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditPortfolioItem");
context.setVariable("MemberProfileEditPortfolioItem", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolioItem.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolioItem.jinja
// module id = 55
// module chunks = 0